import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-header color-lighter" }
const _hoisted_2 = { class: "row gap-2" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import RouteNames from '@/configuration/router/names.routes';
import navigationService from '@/services/NavigationService';
import { onMounted, ref } from 'vue';
import BreadCrumbs from './breadcrumbs/BreadCrumbs.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavHeader',
  setup(__props) {

const showBreadcrumb = ref(false);

onMounted(() => {
  showBreadcrumb.value =
    navigationService.getCurrentRoute().name !== RouteNames.Home;
});

function navigateToHome() {
  navigationService.navigateTo({ name: RouteNames.Home });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppIcon, {
        name: "home",
        size: "body-xl",
        onClick: navigateToHome,
        clickable: true
      }),
      (showBreadcrumb.value)
        ? (_openBlock(), _createBlock(BreadCrumbs, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})